import { TableHead, TableHeadCell, TableHeadRow } from '@/components/Table';
import { useHasCompanyAccess } from '@/hooks/useStore';
import { classes } from './utils';

export type CompanyInvestorsTableHeadProps = {};

export default function CompanyInvestorsTableHead({}: CompanyInvestorsTableHeadProps) {
  const hasCompanyAccess = useHasCompanyAccess();

  return (
    <TableHead className={classes.tableHead}>
      <TableHeadRow>
        <TableHeadCell />
        <TableHeadCell align="left">Name</TableHeadCell>
        <TableHeadCell align="right">Shares</TableHeadCell>
        <TableHeadCell align="right">Price</TableHeadCell>
        <TableHeadCell align="right">Amt. Invested</TableHeadCell>
        <TableHeadCell align="right">Current Price</TableHeadCell>
        <TableHeadCell align="right">Current Value</TableHeadCell>
        <TableHeadCell align="right">Profit/Loss</TableHeadCell>
        {
          hasCompanyAccess && (
            <TableHeadCell />
          ) /* Empty cell for options menu */
        }
      </TableHeadRow>
    </TableHead>
  );
}
